import React from 'react'

import { SliteLogo, SuperSourceIcon } from '@slite/components'
import { AttioGreyIcon, GitHubGreyIcon, LinearGreyIcon } from '@slite/icons'
import { SuperSource } from '@slite/search-client'

import { ORBITE_SIZE_PRESETS, type OrbiteSizePreset } from './constants'

const OrbiteItemContent = ({
  sourceType,
  label,
  size,
}: {
  sourceType?: SuperSource
  label?: React.ReactNode
  size?: number
}) => {
  if (label && !sourceType) {
    return <div className="font-size-7 font-weight-bold shade-10">{label}</div>
  }

  if (sourceType === SuperSource.ATTIO) {
    return <AttioGreyIcon className="shade-10" width={16} />
  }

  if (sourceType === SuperSource.LINEAR) {
    return <LinearGreyIcon className="shade-10" width={16} />
  }

  if (sourceType === SuperSource.GITHUB) {
    return <GitHubGreyIcon className="shade-10" width={16} />
  }

  if (sourceType === SuperSource.SLITE) {
    return (
      <SliteLogo variant="symbol" style={{ width: 16 }} className="shade-10" />
    )
  }

  if (sourceType) {
    return (
      <SuperSourceIcon
        sourceType={sourceType}
        size={size}
        className="shade-10"
      />
    )
  }

  return null
}

type OrbiteItemProps = {
  id?: string
  sourceType?: SuperSource
  size?: OrbiteSizePreset
  label?: React.ReactNode
  x: number
  y: number
  withBackground?: boolean
}

export const OrbiteItem = ({
  id,
  sourceType,
  size = 'medium',
  label,
  x,
  y,
  withBackground = true,
}: OrbiteItemProps) => {
  const preset = ORBITE_SIZE_PRESETS[size]

  return (
    <g id={id} transform={`translate(${x}, ${y})`}>
      <foreignObject
        x={-preset.wrapperSize / 2}
        y={-preset.wrapperSize / 2}
        width={preset.wrapperSize}
        height={preset.wrapperSize}
        style={{ overflow: 'visible' }}
      >
        <div
          style={{
            width: preset.wrapperSize,
            height: preset.wrapperSize,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          className={
            withBackground
              ? 'background-shade-100 shadow-small radius-round'
              : 'border-small border-shade-45 radius-round'
          }
        >
          <OrbiteItemContent
            sourceType={sourceType}
            size={preset.iconSize}
            label={label}
          />
        </div>
      </foreignObject>
    </g>
  )
}
